"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogAppLatencyCF = void 0;
const react_1 = require("react");
const taaConfigs_1 = require("../../../contexts/taaConfigs");
const logger_1 = require("../../../logger");
const useLogAppLatencyCF = (pageName) => {
    const { clientName } = (0, taaConfigs_1.useTaaConfigsContext)();
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (clientName === 'TimeCard') {
            const dimensions = {
                ClientName: clientName,
                ClientType: logger_1.ClientType.WEB,
                PageName: pageName
            };
            logger_1.logger.emitLatencyMetric({
                metricName: 'app.latency.cf',
                metricValue: (_b = (_a = window === null || window === void 0 ? void 0 : window.performance) === null || _a === void 0 ? void 0 : _a.now) === null || _b === void 0 ? void 0 : _b.call(_a),
                dimensions
            });
        }
    }, []);
};
exports.useLogAppLatencyCF = useLogAppLatencyCF;
